"use client";
import { type ComponentPropsWithoutRef } from "react";
import { cn } from "@/shared/lib/utils";
import Link from "next/link";
import { type BaseProps } from "@/shared/lib/types";

interface NavigationLinkConfig
  extends ComponentPropsWithoutRef<typeof Link>,
    BaseProps {
  className?: string;
  href: string;
  label: string;
  disableLink?: boolean;
}

// export default function NavigationLink(
//   config: NavigationLinkConfig,
// ): React.JSX.Element {
//   return (
//     <Link
//       className={cn("border-black border-b-1 border-dotted", config.className)}
//       {...config}
//     >
//       {config.label}
//     </Link>
//   );
// }

export default function NavigationLink({
  disableLink = false,
  ...config
}: NavigationLinkConfig): React.JSX.Element {
  const content = (
    <span className={cn("border-black", config.className)}>{config.label}</span>
  );

  return disableLink ? content : <Link {...config}>{content}</Link>;
}
